import * as clientEntriesSelectors from "./clientEntries";
import * as clientSettingsSelectors from "./clientSettings";
import entitySelectors from "./entities";
import * as typesSelectors from "./types";
export default {
  ...clientEntriesSelectors,
  ...clientSettingsSelectors,
  ...typesSelectors,
  ...entitySelectors
};